"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SskyAuth0Service = void 0;
const authService_1 = require("../authService");
const LEEWAY_MS = 2 * 60 * 1000;
class SskyAuth0Service {
    constructor(config) {
        const auth0 = require("auth0-js");
        const { postLogoutRedirectUri } = config, auth0Options = __rest(config, ["postLogoutRedirectUri"]);
        this.postLogoutRedirectUri = postLogoutRedirectUri;
        this.auth0Options = auth0Options;
        this.authClient = new auth0.WebAuth(auth0Options);
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            yield new Promise((resolve, reject) => {
                // no token in hash --> { error: null, result: null }
                this.authClient.parseHash((error, result) => {
                    if (error) {
                        return reject(error);
                    }
                    if (result) {
                        this.idToken = result.idToken;
                        this.idTokenPayload = result.idTokenPayload;
                    }
                    return resolve();
                });
            });
        });
    }
    isFirstLogin(email) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("Not implemented");
        });
    }
    isUserDeactivated(email) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("Not implemented");
        });
    }
    login(email, password) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("Not implemented"); // This is SSO-only implementation
        });
    }
    loginWithRedirect(email) {
        return __awaiter(this, void 0, void 0, function* () {
            this.authClient.authorize({
                login_hint: email,
                mode: "login"
            });
        });
    }
    loginWithPopup(email) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("Not implemented");
        });
    }
    logout() {
        return __awaiter(this, void 0, void 0, function* () {
            this.authClient.logout({
                clientID: this.auth0Options.clientID,
                returnTo: this.postLogoutRedirectUri
            });
        });
    }
    isUserManaged(email, force) {
        return __awaiter(this, void 0, void 0, function* () {
            return false; // Hard coded for now because this is SSO-only implementation
        });
    }
    getUserAccessToken() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getUserIdToken(); // For Auth0 it is enough to use the id token
        });
    }
    getUserIdToken() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const timeLeft = ((_b = (_a = this.idTokenPayload) === null || _a === void 0 ? void 0 : _a.exp) !== null && _b !== void 0 ? _b : 0) * 1000 - new Date().getTime();
            if (timeLeft <= LEEWAY_MS) {
                yield new Promise((resolve, reject) => {
                    this.authClient.checkSession({}, (error, result) => {
                        if (error) {
                            return reject(error);
                        }
                        this.idToken = result.idToken;
                        this.idTokenPayload = result.idTokenPayload;
                        return resolve();
                    });
                });
            }
            return this.idToken;
        });
    }
    getUserName() {
        var _a;
        return (_a = this.idTokenPayload.email) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    }
    initiateForgotPassword(email) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("Not implemented");
        });
    }
    confirmForgotPassword(email, verificationCode, newPassword) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("Not implemented");
        });
    }
    changePassword(email, oldPassword, newPassword) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("Not implemented");
        });
    }
    subscribe(callback) {
    }
    getAuthServiceType() {
        return authService_1.AuthServiceType.AUTH0;
    }
}
exports.SskyAuth0Service = SskyAuth0Service;
//# sourceMappingURL=SskyAuth0Service.js.map